<template>
  <div>
    <!-- loading -->
    <LoadingSpinner v-if="!loadingDayNonWorking" />
    <div v-else>
      <div
        class="col-md-12 my-4"
        v-if="hasPermissions('superAdmin') && userSelectedIsBdrUser"
      >
        <h5 class="mb-2 text-center">Calendar Availability</h5>
        <CalendarAvailability
          :hours="hours"
          :avalibleSlots="calendarAvailability"
          @SetAvailability="SetAvailability"
        />
      </div>
      <hr />
      <div
        class="col-12 col-md-12 my-2"
        v-if="hasPermissions('superAdmin') && userSelectedIsBdrUser"
      >
        <h5>Non working days</h5>
        <div class="col-12 col-md-12 mb-4 p-0" style="margin-bottom: 310px">
          <date-picker
            id="startDatePicker"
            class=""
            v-model="filterMonth"
            :config="datePickerConfigNonWorkingDays"
            placeholder="Start Date"
          ></date-picker>
        </div>

        <div class="col-12 col-md-12 p-0" v-if="loadingDayNonWorking">
          <multi-date-calendar
            v-model="daysNonWorking"
            :month="dateNonWorking.month"
            :year="dateNonWorking.year"
            :key="keyCalendar"
          >
          </multi-date-calendar>
        </div>
      </div>
      <div class="col-md-12" >
        <button
          @click="saveUserWorkingBooker()"
          class="btn btn-primary w-25 font-weight-bold rounded-pill"
        >
          {{ $t("lang.button.update") }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import CalendarAvailability from "@/components/Calendar/CalendarAvailability.vue";
import { availabilityHasOverlap } from "@/_helpers/timeSlots";
import MultiDateCalendar from "@/components/Common/MultipleDateCalendar.vue";
import LoadingSpinner from "@/components/LoadingSpinner.vue";
import {usersService, bookersService} from "@/_services"; 
import moment from "moment";

export default {
  components: {
    CalendarAvailability,
    MultiDateCalendar,
    LoadingSpinner,
  },
  props: {
    selected: {
      type: Object,
    },
    selectedUserId: {
        type: String,
        default: null,
    },
  },
  data() {
    return {
      loadingDayNonWorking: false,
      datePickerConfigNonWorkingDays: {
        format: "YYYY-MMM",
        viewMode: "months",
        minDate: moment().subtract(12, "month"),
        maxDate: moment().endOf("day"),
      },
      filterMonth: moment().format("YYYY-MMM"),
      keyCalendar: 1,
      dateNonWorking: {
        month: moment().month(),
        year: moment().year(),
      },
      daysNonWorking: [],
      calendarAvailability: [],
      hours: [
        { id: 8, label: "08:00 hs" },
        { id: 9, label: "09:00 hs" },
        { id: 10, label: "10:00 hs" },
        { id: 11, label: "11:00 hs" },
        { id: 12, label: "12:00 hs" },
        { id: 13, label: "13:00 hs" },
        { id: 14, label: "14:00 hs" },
        { id: 15, label: "15:00 hs" },
        { id: 16, label: "16:00 hs" },
        { id: 17, label: "17:00 hs" },
        { id: 18, label: "18:00 hs" },
        { id: 19, label: "19:00 hs" },
      ],
    };
  },
  watch: {
    filterMonth(newValue) {
      this.dateNonWorking.month = moment(newValue).month();
      this.dateNonWorking.year = moment(newValue).year();
      this.getDayByMonth(
        `${this.dateNonWorking.year}-${moment(newValue).format("MM")}`
      );
      this.keyCalendar++;
    },
  },
  computed: {
    userSelectedIsBdrUser() {
      return this.selected.user.team_role_id == 2 &&
        this.selected.user.role_id == 2
        ? true
        : false;
    },
  },
  created(){
  const availability = this.selected.user.working_hours_availability;
  try {
    if (!availability) {
      this.calendarAvailability = [];
    } else if (typeof availability === "string") {
      this.calendarAvailability = availability.trim().length > 0 ? JSON.parse(availability) : [];
    } else if (Array.isArray(availability)) {
      this.calendarAvailability = [];
    }
  } catch (error) {
    this.calendarAvailability = [];
  }
    this.getDayByMonth(
      `${this.dateNonWorking.year}-${moment(this.filterMonth).format("MM")}`
    );
  },
  mounted() {
    this.keyCalendar++;
  },
  methods: {
    hasPermissions(perm) {
      return this.$store.getters["authentication/hasPermissions"](perm);
    },
    SetAvailability(days) {
      this.calendarAvailability = days;
    },
    getDayByMonth(yearMonth) {
      this.loadingDayNonWorking = false;
      usersService
        .getNonWorkingDays(yearMonth, this.selectedUserId)
        .then((res) => {
          this.daysNonWorking = res;
          this.loadingDayNonWorking = true;
          this.keyCalendar++;
        })
        .catch((err) => console.log(err));
    },
    validateHours() {
      return this.calendarAvailability.every(item =>
        item.hours.every(hour => hour.to > hour.from)
      ) && !availabilityHasOverlap(this.calendarAvailability);
    },
    saveUserWorkingBooker() {
      const yearMonth = moment(this.filterMonth).format("YYYY-MM");
      const dayNotWorking = {
        yearMonth: yearMonth,
        days: Array.isArray(this.daysNonWorking)
          ? this.daysNonWorking.filter((el) => el.substr(0, 7) === yearMonth)
          : [],
      };
      const isValidHours = this.validateHours();
      if(!isValidHours){
        this.$swal({
          type: "error",
          title: "Please enter the correct time range.",
          showConfirmButton: false,
          timer: 3500,
        });
        return;
      }
      bookersService
        .saveUserWorkingBooker(this.selectedUserId, this.calendarAvailability, dayNotWorking)
        .then((res) => {
        this.$swal({
            type: "success",
            title: this.$t("lang.label.great"),
            text: this.$t('lang.label.datasavedsuccessfully'),
            showConfirmButton: false,
            timer: 5000,
            });
        }).then(()=>{
          this.filterMonth = moment().format("YYYY-MMM");
          this.$emit("getUser");
        })
    },
  },
};
</script>
